import gql from "graphql-tag";
import UserSettings from "../fragments/UserSettings";

export default gql`
  mutation CloseRemessaOnlineDiscount {
    closeRemessaOnlineDiscount {
      _id
      ...UserSettings
    }
  }

  ${UserSettings}
`;
